/**
 * @desc 根据sku编号查询sku详细信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlmSkuDetailInfoResponseRpcDto>;
export function request(sku: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getSkuDetailBySkuNo/${sku}`, {
      method: "GET",

      ...options,
    }),
  );
}
